import _ from 'underscore';
import ViewerSocialProfile from 'models/user/ViewerSocialProfile';

var RoleUtils = {
    isWellnessUser: function() {
        var wellnessUser = false;

        var roles = ViewerSocialProfile.get('userRoles');

        for (var i = 0; i < roles.length; i++) {
            if (roles[i] === 'ROLE_WELLNESS_USER') {
                wellnessUser = true;
            }
        }

        return wellnessUser;
    },

    isFitnessUser: function() {
        var fitnessUser = false;

        var roles = ViewerSocialProfile.get('userRoles');

        for (var i = 0; i < roles.length; i++) {
            if (roles[i] === 'ROLE_FITNESS_USER') {
                fitnessUser = true;
            }
        }

        return fitnessUser;
    },

    isWellnessUserOnly: function() {
        var fitnessUser = false;
        var wellnessUser = false;

        var roles = ViewerSocialProfile.get('userRoles');

        for (var i = 0; i < roles.length; i++) {
            if (roles[i] === 'ROLE_FITNESS_USER') {
                fitnessUser = true;
            } else if (roles[i] === 'ROLE_WELLNESS_USER') {
                wellnessUser = true;
            }
        }

        return fitnessUser == false && wellnessUser == true;
    },

    isFitnessUserOnly: function() {
        var fitnessUser = false;
        var wellnessUser = false;

        var roles = ViewerSocialProfile.get('userRoles');

        for (var i = 0; i < roles.length; i++) {
            if (roles[i] === 'ROLE_FITNESS_USER') {
                fitnessUser = true;
            } else if (roles[i] === 'ROLE_WELLNESS_USER') {
                wellnessUser = true;
            }
        }

        return fitnessUser == true && wellnessUser == false;
    },

    isDiveUserOnly: function() {
        var roles = ViewerSocialProfile.get('userRoles');
        return (
            _.intersection(roles, ['ROLE_FITNESS_USER', 'ROLE_WELLNESS_USER', 'ROLE_OUTDOOR_USER', 'ROLE_MARINE_USER'])
                .length === 0 && _.indexOf(roles, 'ROLE_DIVE_USER') >= 0
        );
    },

    isProUser: function() {
        var proUser = false;
        var roles = ViewerSocialProfile.get('userRoles');

        for (var i = 0, length = roles.length; i < length; i++) {
            if (roles[i] === 'ROLE_CONNECTPRO') {
                proUser = true;
            }
        }

        return proUser;
    }
};

export default RoleUtils;
